import script from "./AccountsRow.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountsRow.vue?vue&type=script&setup=true&lang=js"

import "./AccountsRow.vue?vue&type=style&index=0&id=46508b4d&lang=css"

const __exports__ = script;

export default __exports__